import { CustomComponentProps } from "utils/types/generalTypes";

export type ToolTipV2Props = CustomComponentProps & {
    text: string;
    children: React.ReactNode;
};

const ToolTipV2 = ({ text, children, className, style }: ToolTipV2Props) => {
    return (
        <div
            className={`tool-tip-parent p-relative ${className}`}
            style={style}
        >
            <div className="social-count-tooltip momeento-p">{text}</div>
            {children}
        </div>
    );
};

export default ToolTipV2;
